import { GlobalLocation } from "../../../application/GeoLocation";
export class CountryQualifier {
    constructor() {
        this.key = "Country";
    }
    process() {
        const Unknown = 'unknown';
        const countryCode = GlobalLocation.getCountryCode();
        return countryCode !== null && countryCode !== void 0 ? countryCode : Unknown;
    }
}
